<template>
  <div class="dashboard fit-height">
    <h1 class="auto-height headline">Hi, {{ CURRENT_USER.first_name }}</h1>
    <div class="with-sidebar">
      <div class="body">
        <h4 class="headline mb-4">MY ACTIVE JOBS</h4>
        <div class="table-responsive">
          <table class="table table-sm table-hover">
            <thead>
              <tr>
                <th><a href="javascript:;" data-sort-field="job_no"  class="sort" @click="doSort($event)">JOB NO</a></th>
                <th v-if="!IS_CLIENT"><a href="javascript:;" data-sort-field="client_name" class="sort" @click="doSort($event)">COMPANY</a></th>
                <th><a href="javascript:;" data-sort-field="job_name" class="sort" @click="doSort($event)">JOB NAME</a></th>
                <th><a href="javascript:;" data-sort-field="job_status" class="sort" @click="doSort($event)">STATUS</a></th>
                <th><a href="javascript:;" data-sort-field="job_updated_at" class="sort" @click="doSort($event)">LAST UPDATED</a></th>
              </tr>
            </thead>
            <tbody>
            <tr v-for="(job, index) in jobs" :key="index" @click="gotoJob(job.id)" style="cursor: pointer;">
              <td><strong>{{ job.id }}</strong></td>
              <td v-if="!IS_CLIENT">{{ job.client.name }}</td>
              <td>{{ job.name }}</td>
              <td>{{ job.status | statusToUCWords }}</td>
              <td>{{ job.updated_at | toHumanDate('Do MMM YYYY') }}</td>
            </tr>
            <tr v-if="jobs.length == 0">
              <td colspan="5" class="text-center">No active jobs</td>
            </tr>
            </tbody>
          </table>
          <div class="d-flex justify-content-between">
            <pagination :total-pages="totalPages" :current-page="currentPage"  @goto-page="doPaging"></pagination>
          </div>
        </div>
        <div v-if="IS_CLIENT">
          <br/><br/>
          <h4 class="headline mb-4">MY ACTIVE REQUESTS</h4>
          <div class="table-responsive">
            <table class="table table-sm table-hover">
              <thead>
              <tr>
                <th>REQUEST NO</th>
                <th>CONTACT</th>
                <th>JOB NAME</th>
                <th>STATUS</th>
                <th>LAST UPDATED</th>
              </tr>
              </thead>
              <tbody>
              <tr style="cursor: pointer;" v-for="(req, index) in requests" :key="index" @click="editRequest(index)">
                <td><strong>{{ req.id }}</strong></td>
                <td>{{ req.contact?req.contact.full_name:'' }}</td>
                <td>{{ req.name }}</td>
                <td>{{ req.status | statusToUCWords }}</td>
                <td>{{ req.updated_at | toHumanDate('Do MMM YYYY') }}</td>
              </tr>
              <tr v-if="requests.length == 0">
                <td colspan="5" class="text-center">No requests found</td>
              </tr>
              </tbody>
            </table>
            <div class="d-flex justify-content-between">
              <pagination :total-pages="totalPages" :current-page="currentPage"  @goto-page="doPaging"></pagination>
            </div>
          </div>
        </div>
      </div>
      <aside class="sidebar">
        <template v-if="IS_CLIENT" >
          <button type="button" class="btn btn-outline-black" @click="showModalAdd = true">Request New Job</button>
          <modal-add-job-request v-model="showModalAdd" @close="onJobRequestClose"></modal-add-job-request>
        </template>
        <todo-list v-else></todo-list>
      </aside>
      <modal-edit-job-request v-model="showModalEdit" :request="selectedRequest" @close="onJobRequestClose"></modal-edit-job-request>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import jquery from "jquery"
import ServiceJob from '@/services/job'
import ServiceJobRequest from '@/services/jobrequest'
import TodoList from './TodoList'
import ModalAddJobRequest from '@/components/global/ModalAddJobRequest'
import ModalEditJobRequest from '@/components/global/ModalEditJobRequest'

export default {
  components: {
    TodoList,
    ModalAddJobRequest,
    ModalEditJobRequest
  },
  data () {
    return {
      state: 'loading',
      showModalAdd: false,
      showModalEdit: false,
      currentPage: 1,
      totalPages: 0,
      jobs: [],
      requests: [],
      client_id: null,
      todo_list: [],
      sort: '',
      order: 'asc',
      selectedRequest: null
    }
  },
  computed: {
    ...mapGetters(['CURRENT_USER', 'IS_CLIENT'])
  },
  mounted () {
    this.init();
  },
  methods: {
    init () {
      this.getJobs();
      this.showModalAdd = false;
      this.showModalEdit = false;
      if (this.IS_CLIENT) {
        this.getRequests();
      }
    },
    doSort (event) {
      let self = this, header = event.target;

      // Go through all header and reset the sort class
      jquery('.sort').not(header).attr('class', 'sort');

      if (typeof header.dataset.sortField != 'undefined') {
        self.sort = header.dataset.sortField;
        if (header.className.indexOf('asc') == -1) {
          /* Not sort or in desc */
          self.order = 'asc';
          header.className = header.className.replace(' desc', '') + ' asc';
        } else if (header.className.indexOf('desc') == -1) {
          self.order = 'desc';
          header.className = header.className.replace(' asc', '') + ' desc';
        }
        self.getJobs();
      }
    },
    doPaging ( page ) {
      let self = this;
      self.currentPage = page;
      self.getJobs();
    },
    _getParams(){
      let self = this,
        params = {
          page: self.currentPage,
          status: 'in_progress',
          sort: self.sort,
          order: self.order,
        };
      if(self.IS_CLIENT){
        params['client_id'] = self.CURRENT_USER.client_id;
      }else{
        params['user_id'] = self.CURRENT_USER.id;
      }
      return params;
    },
    getJobs () {
      let self = this;
      let params = self._getParams();
      self.state = 'loading';
      ServiceJob.getJobs(params, resp => {
        self.state = 'loaded';
        self.jobs = resp.data;
        self.totalPages = resp.last_page;
        self.totalItems = resp.total;
      });
    },
    onJobRequestClose () {
      this.showModalAdd = false;
      this.showModalEdit = false;
      this.getRequests();
    },
    gotoJob(jobId) {
      this.$router.push({name: 'job', params: {jobId: jobId}});
    },
    getRequests () {
      let self = this;
      let params = {
        ipp: 'all',
        client_id: self.CURRENT_USER.client_id,
        status: ['pending']
      };
      self.state = 'loading';
      ServiceJobRequest.getJobRequests(params, resp => {
        self.state = 'loaded';
        self.requests = resp;
      });
    },
    editRequest(index) {
      let self = this;
      self.selectedRequest = self.requests[index];
      self.showModalEdit = true;
    }
  }
}
</script>
